import { readPersistedAgentBotSelection, isAgentBotSelectionValid } from '@/store/agentSelectedBot.store';

/** User slice used for post-login routing (must stay in sync with `RoleBasedRedirect` in routes). */
export type HomePathUser = {
  role?: string | null;
  tenantId?: string | null;
  agentBotIds?: string[] | null;
};

/**
 * Default landing path after login / "go home".
 * Agents land on Home; a modal opens when no valid saved workspace bot exists.
 */
export function getHomePathForUser(user?: HomePathUser | null): string {
  if (user?.role?.toLowerCase() === 'agent') {
    const persisted = readPersistedAgentBotSelection();
    if (persisted && isAgentBotSelectionValid(user, persisted)) {
      return '/dashboard';
    }
    return '/dashboard?pickBot=1';
  }
  return '/dashboard';
}
